import { Button, makeStyles, Modal } from '@material-ui/core';
import React, { useState } from 'react';
import './Device-Restart-Popup.scss';

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: 'none',
    borderRadius: '10px',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

const DeviceRestartPopup = (props) => {
  const classes = useStyles();
  const { currentStatus, onCancel, onRestart, selectedCount } = props;
  const [modalStyle] = useState(getModalStyle);

  const handleOnSubmit = () => {
    onRestart();
  };

  const body = (
    <div style={modalStyle} className={classes.paper}>
      <div className='my-4 device-popup d-flex flex-column'>
        <div className='mb-3'>
          <div className='device-popup-header mb-2 text-center'>
            Are you sure you want to restart
            <div>these {selectedCount} devices?</div>
          </div>
        </div>

        <div className='w-100 d-flex justify-content-center'>
          <Button onClick={onCancel} variant='outlined' type='button' className='me-3' size='large'>
            No
          </Button>
          <Button
            onClick={(e) => {
              handleOnSubmit();
            }}
            variant='contained'
            type='submit'
            color={'primary'}
            className='me-3'
            size='large'
          >
            Yes
          </Button>
        </div>
      </div>
    </div>
  );

  return (
    <Modal open={currentStatus.warn} onClose={onCancel}>
      {body}
    </Modal>
  );
};

export default DeviceRestartPopup;
